export const transliteration = {
  methods: {
    transliterate (word) {
      const transformWord = word.toLowerCase().replace(/[^a-z0-9 \u0400-\u04FF]/gi, '')
      const letters = { 'і': 'i', 'ї': 'i', 'є': 'e', 'ё': 'yo', 'й': 'i', 'ц': 'ts', 'у': 'u', 'к': 'k', 'е': 'e', 'н': 'n', 'г': 'g', 'ш': 'sh', 'щ': 'sch', 'з': 'z', 'х': 'h', 'ъ': '-', 'ф': 'f', 'ы': 'i', 'в': 'v', 'а': 'a', 'п': 'p', 'р': 'r', 'о': 'o', 'л': 'l', 'д': 'd', 'ж': 'zh', 'э': 'e', 'я': 'ya', 'ч': 'ch', 'с': 's', 'м': 'm', 'и': 'i', 'т': 't', 'ь': '-', 'б': 'b', 'ю': 'yu' }
      const result = transformWord.split('').map((char) => letters[char] || char).join('')
      return result.split(' ').join('-')
    }
  }
}
